import { AnalyticsEvent } from '@buyiq-core/models/analytics';
import { InjectionToken } from '@angular/core';

export interface IAnalyticsService {
    trackEvent(event: AnalyticsEvent): void;
}

export const ANALYTICS_SERVICE = new InjectionToken<IAnalyticsService>('AnalyticsService');

